import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:`
  <div class="overlay" *ngIf="showAlert">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Close
          </button>
        </div>
      </div>
    </div>
  `
})
export class LogoutPage{
 key = '';
 showAlert = false;
 errorMessage = '';
  whatsAppUrl = environment.whatsapp_url;
  constructor(private route: ActivatedRoute, 
              private authService: AuthService,
              private sessionService: SessionService) {}
  ngOnInit() {
    this.key = this.route.snapshot.paramMap.get('key') ?? '';
    if (!this.key) {
        window.location.href = this.whatsAppUrl;
      return;
    }
    this.Logout();
  }
  Logout(){
    this.authService
      .postManualLogout(this.key)
      .subscribe({
          next: response => {
              this.showAlert = false;
              this.sessionService.clear();
              window.location.href = this.whatsAppUrl;
          },
          error: err => {
             if (err.status === 401) {
                this.showAlert = false;
                this.sessionService.clear();
                window.location.href = this.whatsAppUrl;
             }
            this.errorMessage = err.error?.message ?? 'Failed to logout.';
            this.showAlert = true;
          }
        },
      );
    }
closeErrorPopup(): void {
    window.location.href = this.whatsAppUrl;
  }
}